module.exports = __webpack_public_path__ + "img/pl_meals_guide.d09cb832.jpg";